import { useFragmentQuery } from '@app/modules/fragments/hooks/useFragment';
import { FragmentViewNavigationState } from '@app/modules/fragments/routing/FragmentsRoutes';
import { useLocation, useParams } from 'react-router';

export function usePreviewFragment() {
  const { fragmentId } = useParams<{ fragmentId: string }>();
  const query = useFragmentQuery(fragmentId!);
  const location = useLocation<FragmentViewNavigationState | undefined>();
  const fragmentFromNavigation = location.state?.fragment;

  return {
    query,
    fragmentFromNavigation,
    fragment: query.data,
  };
}
